export const SIZE_KEYS = ["width", "height"] as const
export const MARGINS_KEYS = ["top", "right", "bottom", "left"] as const
export const POINT_KEYS = ["x", "y"] as const
